var _path, _g, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP2PLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 60,
    viewBox: "0 0 58 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1639_3529)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1639_3529)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1639_3529",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 58,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.9977 0.499878H0V59.4999H57.9977V0.499878Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1639_3529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 0.499878C12.9827 0.499878 2.70414e-05 13.6575 2.70414e-05 29.8905C-0.00955586 36.9978 2.52814 43.8649 7.13785 49.2058L8.63434 43.8716L12.4739 30.4034L13.7044 26.0881L14.4746 23.394C14.5509 23.0975 14.6342 22.8058 14.7267 22.5163C15.2327 20.9357 15.9805 19.446 16.9425 18.1022C18.9974 15.2298 21.8899 13.0892 25.2091 11.9846C26.72 11.4804 28.2924 11.1922 29.8813 11.1281C30.1126 11.1281 30.3577 11.1093 30.5983 11.1093C33.0838 11.1048 35.5406 11.6499 37.7986 12.7069C39.1462 13.3423 40.4047 14.1573 41.5409 15.1305C42.5626 16.0037 43.4753 17.0009 44.2587 18.0999C45.9323 20.4389 46.9391 23.2022 47.1684 26.0858C47.2008 26.5046 47.2239 26.9234 47.2239 27.3493C47.2193 30.8076 46.0969 34.1685 44.0297 36.914C41.5479 40.2316 37.8333 42.7493 33.4988 43.3328C27.7163 44.1069 20.5461 43.8669 20.5461 43.8669H16.1168L13.1331 54.4952C17.8513 57.6277 23.3658 59.291 29 59.2811C45.015 59.2811 58 46.1234 58 29.8905C58 13.6575 45.015 0.499878 29 0.499878Z",
    fill: "url(#paint0_linear_1639_3529)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2594 28.394C46.0591 25.8665 45.1789 23.444 43.7151 21.3916C43.0274 20.4286 42.2266 19.5547 41.3305 18.7893C40.3351 17.9387 39.2329 17.2265 38.053 16.6716C36.0734 15.746 33.9196 15.2691 31.7409 15.274C31.5304 15.274 31.3199 15.274 31.1118 15.2904C29.7162 15.3421 28.3345 15.5908 27.0062 16.0293C24.097 16.998 21.5616 18.8742 19.7597 21.3916C18.915 22.5694 18.2571 23.8747 17.8099 25.2598C17.7289 25.5163 17.6572 25.7728 17.5786 26.0316L16.9055 28.3846L15.8277 32.1657L12.49 43.9822L7.63281 59.4834H14.1762L19.0334 43.9822H22.9192C22.9192 43.9822 29.2128 44.194 34.2713 43.5116C38.0715 43.001 41.3281 40.7916 43.5023 37.8857C45.3124 35.4783 46.2957 32.5331 46.301 29.5022C46.308 29.1304 46.2871 28.761 46.2594 28.394Z",
    fill: "url(#paint1_linear_1639_3529)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8303 37.1022C32.0693 37.1705 31.1256 37.2152 29.9738 37.2269L27.8713 37.2058H23.7704L22.792 39.9728H22.8452H29.9668C33.5057 39.9728 36.7461 38.0905 38.0183 34.3117C38.0183 34.3069 35.4416 36.7046 32.8303 37.1022Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0633 33.9235L13.9448 59.4835H17.1321C18.3048 59.4835 19.5607 58.5164 19.9377 57.3235L27.3739 33.9235H22.0633Z",
    fill: "url(#paint2_linear_1639_3529)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8898 24.9705L23.5552 29.2058H26.7424C27.9151 29.2058 29.1711 28.2387 29.5481 27.0458L30.7046 23.3776L24.8898 24.9705Z",
    fill: "url(#paint3_linear_1639_3529)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3679 27.0293C25.1952 27.0293 23.9393 27.9964 23.5622 29.1893L25.2669 23.7776C25.6416 22.5846 26.8975 21.6176 28.0725 21.6176H35.1918C39.1031 21.6176 41.2564 24.8411 40.0028 28.8199C38.7492 32.7987 34.5558 36.0293 30.6445 36.0293H23.5229C22.3502 36.0293 21.0943 36.9964 20.7173 38.1893L22.4196 32.7775C22.7966 31.5846 24.0526 30.6176 25.2253 30.6176H32.3469C33.3253 30.6176 34.3707 29.8105 34.6853 28.8152C34.9999 27.8199 34.454 27.0152 33.4826 27.0152L26.3679 27.0293Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1639_3529",
    x1: 26.1204,
    y1: 30.754,
    x2: 72.5206,
    y2: 17.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A8AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04EECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1639_3529",
    x1: 21.3325,
    y1: 66.3446,
    x2: 36.7363,
    y2: 10.9848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04EECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A8AFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1639_3529",
    x1: 16.7848,
    y1: 59.1188,
    x2: 16.7848,
    y2: 32.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E4E7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#CCD3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#AAB6BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8C9DA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1639_3529",
    x1: 26.2673,
    y1: 29.0693,
    x2: 26.2673,
    y2: 26.9729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C9DA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1639_3529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 59,
    fill: "white",
    transform: "translate(0 0.499878)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1639_3529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 59,
    fill: "white",
    transform: "translate(0 0.499878)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2PLogo);
export default __webpack_public_path__ + "static/media/P2P_Logo.d741753ecdf66868095f64836d6f73c0.svg";
export { ForwardRef as ReactComponent };